import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '730px',
    minWidth: '299px',
    width: '100%',
    alignSelf: 'center',
    marginBottom: '90px',
  },
  pageTitle: {
    [theme.breakpoints.down('sm')]: {
      marginTop: '15px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '23px',
    },
    fontSize: '33px',
    fontWeight: '400',
    color: '#fff',
    marginBottom: '35px',
  },
  section: {
    marginBottom: '20px',
  },
  stepHeader: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
    fontSize: '16px',
    marginBottom: '20px',
    color: '#fff',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
  },
  noMargin: {
    margin: '0',
  },
  stepHeaderChecked: {
    width: '19px',
    height: '18px',
    marginRight: '9px',
  },
  stepHeaderNum: {
    marginRight: '9px',
    fontSize: '13px',
    borderRadius: '50%',
    border: '2px solid #fff',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2px',
  },
  gridBottomItems: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    marginTop: '5px',
  },
  nsfwBlockedText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '8px',
    },
    fontSize: '12px',
    fontWeight: '300',
    color: '#ff0000',
  },
  fileLength: {
    color: '#fff',
    fontSize: '12px',
    fontWeight: '400',
    textAlign: 'right',
    justifyContent: 'flex-end',
  },
  titleTooltipImg: {
    [theme.breakpoints.down('xs')]: {
      width: '14px',
      marginTop: '0',
    },
    width: '16px',
    marginLeft: '4px',
    marginTop: '1px',
  },
  tooltipImg: {
    [theme.breakpoints.down('xs')]: {
      width: '14px',
      marginTop: '0',
    },
    width: '16px',
    marginTop: '3px',
  },
  dragAndDropText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px',
      lineHeight: '14px',
    },
    fontWeight: '300',
    fontSize: '16px',
    color: '#ffffff',
    textAlign: 'center',
    lineHeight: '19px',
  },
  addButtonImg: {
    [theme.breakpoints.down('xs')]: {
      width: '17px',
      height: '17px',
      marginRight: '5px',
    },
    width: '25px',
    height: '25px',
    marginRight: '10px',
  },
  dragAndDropList: {
    padding: '10px !important',
    backgroundColor: '#1C1C1C',
    borderRadius: '8px !important',
    marginTop: '10px',
    maxHeight: '200px',
    gap: '6px',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: '8px',
      marginRight: '5px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#404040',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#9A9A9A',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#9A9A9A',
    },
  },
  gridItem: {
    [theme.breakpoints.down('xs')]: {
      width: '96px',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '6px',
    width: '112px',
    position: 'relative',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  gridItemImage: {
    [theme.breakpoints.down('xs')]: {
      width: '88px',
      height: '88px',
    },
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '8px',
  },
  gridThumnailTag: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '8px',
    },
    position: 'absolute',
    zIndex: '3',
    borderRadius: '1rem',
    padding: '3px 5px',
    fontSize: '10px',
    fontWeight: '400',
    color: '#000',
    backgroundColor: '#fff',
    top: '12px',
    left: '10px',
    border: '1px solid #e2e2e2',
  },
  nsfwBlocked: {
    [theme.breakpoints.down('xs')]: {
      top: '9.5px',
      left: '7.6px',
    },
    position: 'absolute',
    zIndex: '3',
    top: '16px',
    left: '16px',
    fontSize: '80px !important',
    color: '#ff0000',
  },
  nsfwChecking: {
    [theme.breakpoints.down('xs')]: {
      top: '28px',
      left: '28px',
    },
    width: '40px !important',
    height: '40px !important',
    position: 'absolute',
    top: '36px',
    left: '36px',
    zIndex: '3',
    '&.MuiCircularProgress-root': {
      color: '#fff',
      filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
    },
  },
  gridItemText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '11px!important',
      padding: '0 4px',
    },
    maxWidth: '100px',
    fontSize: '14px!important',
    color: '#fff',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    wordBreak: 'break-all',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
  },
  gridItemDeleteButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    '&.MuiButton-text': {
      padding: '0',
    },
  },
  gridDeleteIcon: {
    color: '#fff',
    width: '20px',
    filter: 'drop-shadow(0 0 4px rgba(0,0,0,0.6))',
  },
  listDeleteIcon: {
    color: '#fff',
    width: '20px',
  },
  labelInput: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
    fontSize: '16px !important',
    width: '100%',
    color: '#9a9a9a',
    padding: '10px',
    backgroundColor: '#292929',
    border: '1px solid #9A9A9A',
    borderRadius: '8px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  usageButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  usageButton: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px !important',
    },
    fontSize: '16px !important',
    textAlign: 'center',
    lineHeight: '1.25',
    padding: '10px',
    width: '48%',
    color: '#9a9a9a',
    backgroundColor: '#292929',
    border: '1px solid #9A9A9A',
    borderRadius: '8px !important',
    cursor: 'pointer',
  },
  sliderRoot: {
    color: '#fff',
    marginBotton: '-1rem',
    width: '95%',
    marginTop: '0.5rem',
    marginBottom: '-0.5rem',
    '& .MuiSlider-thumb': {
      width: '1rem',
      height: '1rem',
      borderRadius: '50%',
      backgroundColor: '#fff',
      boxShadow: '0 0 0.5rem 0 rgba(1, 1, 1, 0.40)',
      zIndex: '5',
      '&:focus, &:hover, &.Mui-active': {
        boxShadow: 'inherit',
      },
    },
    '& .MuiSlider-track': {
      border: '1px solid white',
      backgroundColor: '#fff',
      zIndex: '3',
    },
    '& .MuiSlider-rail': {
      backgroundColor: '#fff',
      zIndex: '1',
    },
    '& .MuiSlider-mark': {
      width: '0.7rem',
      height: '0.7rem',
      borderRadius: '50%',
      backgroundColor: 'grey',
      marginLeft: '-0.25rem',
      zIndex: '2',
    },
    '& .MuiSlider-markLabel': {
      [theme.breakpoints.down('xs')]: {
        fontSize: '12px !important',
      },
      fontSize: '16px !important',
      color: '#9a9a9a',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  submitContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  infoContainer: {
    display: 'flex',
    alignItems: 'start',
  },
  coinContainer: { marginLeft: '4px' },
  coin: {
    [theme.breakpoints.down('xs')]: {
      height: '1rem',
      fontSize: '0.65rem',
    },
    height: '1.5rem',
    fontSize: '0.8rem',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  button: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
      fontSize: '11px',
      minWidth: '100px',
    },
    backgroundColor: '#CAFF73',
    padding: '10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'pointer',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  loadingText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
    fontSize: '16px',
    marginLeft: '16px',
    lineHeight: '22px',
    color: '#fff',
    fontWeight: '300',
  },
  dragAndDrop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  separater: {
    borderBottomWidth: '1px',
    borderBottomColor: '#686868',
    borderBottomStyle: 'solid',
    margin: '1.5rem 0',
  },
  greyout: {
    color: '#888888',
    '& $stepHeaderNum': {
      border: '2px solid #888888',
    },
  },
  disabledButton: {
    backgroundColor: '#A4A4A4!important',
    cursor: 'not-allowed',
  },
  progressButton: {
    [theme.breakpoints.down('xs')]: {
      padding: '10px 10px 10px 15px',
      fontSize: '11px',
      minWidth: '95px',
    },
    backgroundColor: '#A4A4A4!important',
    padding: '10px 20px 10px 30px',
    fontSize: '16px',
    textAlign: 'center',
    borderRadius: '8px',
    minWidth: '120px',
    cursor: 'not-allowed',
    display: 'flex',
  },
  loadingCircle: {
    [theme.breakpoints.down('xs')]: {
      width: '11px!important',
      height: '11px!important',
      marginLeft: '5px',
    },
    marginLeft: '5px',
    width: '15px!important',
    height: '15px!important',
  },
}));

export { useStyles };
